export enum ActionKeys {
  ViewFile = 'viewFile',
  ViewFileNewTab = 'viewFileNewTab',
  ViewFolder = 'viewFolder',
  ViewFolderNewTab = 'viewFolderNewTab',
  AddToFavorites = 'addToFavorites',
  RemoveFromFavorites = 'removeFromFavorites',
  ViewFileDetails = 'viewFileDetails',
  ViewFolderDetails = 'viewFolderDetails',
  OpenDetailsPanel = 'openFileDetailsPanel',
  Move = 'move',
  Edit = 'edit',
  Copy = 'copy',
  Share = 'share',
  DeleteFile = 'deleteFile',
  DeleteFolder = 'deleteFolder',
  RenameFolder = 'renameFolder',
  RenameFile = 'renameFile',
  EditFileTags = 'editFileTags',
  GenerateKeypoints = 'generateKeypoints',
  AddToSharebox = 'addToSharebox',
}
